import { render, staticRenderFns } from "./AboutDementia.vue?vue&type=template&id=8fbbb420"
import script from "./AboutDementia.vue?vue&type=script&lang=js"
export * from "./AboutDementia.vue?vue&type=script&lang=js"
import style0 from "./AboutDementia.vue?vue&type=style&index=0&id=8fbbb420&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports